import React, { useEffect, useState } from 'react'
import PageTransition from '../components/PageTransition'
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { auth, db, storage } from '../firebase-config'
import { onAuthStateChanged, updateProfile } from 'firebase/auth'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import useRippleEffect from '../hooks/useRippleEffect';
import imageCompression from 'browser-image-compression';
// CSS
import '../assets/css/edit-profile.css'
// Images
import Avatar from '../assets/images/avatar.png'
import { uploadBytes } from 'firebase/storage'

export default function EditProfile(props) {
  useRippleEffect();

  const navigate = useNavigate();
  const uid = auth.currentUser.uid;
  const [userData, setUserData] = useState();
  const [avatar, setAvatar] = useState(Avatar);
  
  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  useEffect(() => {
    getDoc(doc(db, 'Users', uid)).then((doc) => {
      const data = doc.data().data;

      $('.name').val(data.name);
      $('.bio').val(data.bio);
      $('.email').val(data.email);
      $('.mobile_number').val(data.mobileNumber);
      setAvatar(data.photoURL);

      setUserData(data)
    });
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const bio = e.target.bio.value;
    
    if(name !== userData.name || bio !== userData.bio){
      updateDoc(doc(db, 'Users', uid), {
        "data.name": name,
        "data.bio": bio
      }).then(() => {
        updateProfile(auth.currentUser, {
          displayName: name,
        }).then(() => {
          navigate('/profile');
        })
      });
    }

    if(document.querySelector('#profile_pic_preview').src !== avatar){
      const file = document.querySelector('#profile_pic_input').files[0];
      console.log(file.name)
      const fileName = file.name+'_'+uid;

      $('.profile_pic_input .loader').addClass('show');

      const compressionOptions = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 350,
        useWebWorker: true
      }

      if(avatar.includes('https://ui-avatars.com') === false){
        deleteObject(ref(storage, '/Profile Pictures/' + userData.photoPath)).then(() => {
          console.log('deleted photo');
        })
      }
      
      imageCompression(file, compressionOptions).then(function(compressedFile) {
        const storageRef = ref(storage, "/Profile Pictures/"+fileName);
        const uploadTask = uploadBytesResumable(storageRef, compressedFile);
      
        uploadTask.on('state_changed', (snapshot) => {
            
        }, (error) => {
          alert('Error Please try again');
          console.log(error)
        }, () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            updateDoc(doc(db, "Users", uid), {
              "data.photoURL": downloadURL,
              "data.photoPath": fileName
            }).then(() => {
              updateProfile(auth.currentUser, {
                photoURL: downloadURL
              }).then(() => {
                $('.profile_pic_input .loader').removeClass('show');
                navigate('/profile');
              })
            })
          });
        });
      });
    }
  }

  function handleFormChange(){
    const photoURL = document.querySelector('#profile_pic_preview').src;
    const name = $('.name').val();
    const bio = $('.bio').val();

    console.log(name, userData)

    if(name == userData.name && bio == userData.bio && photoURL == userData.photoURL){
      document.querySelector('.submit_btn').disabled = true;
      return;
    }
    if(name !== userData.name || bio !== userData.bio || photoURL !== userData.photoURL){
      document.querySelector('.submit_btn').disabled = false;
    }
  }

  return (
    <div className='edit_profile_page form_page page_body'>
      <PageTransition />
      <div className='container'>
        <form className='form_primary edit_profile_form' onChange={handleFormChange} onSubmit={handleSubmit} id='edit_profile_form'>
          <div className='header'>
            <div className='form_title'>Edit Your Profile</div>
          </div>

          <div className='inputs'>
            <div className='input_container profile_pic_input'>
              <div className='preview bx_shadow_round'>
                <img src={avatar} id='profile_pic_preview' alt='Profile Pic' />
                <button type='button' className='fas fa-camera' onClick={() => {$('#profile_pic_input').click()}}></button>
                <div className='loader'><span className='fas fa-spinner'></span></div>
              </div>
              <input type='file' onChange={(e) => {document.querySelector('#profile_pic_preview').src = URL.createObjectURL(e.target.files[0])}} name='profile_pic' id='profile_pic_input' accept='image/*' />
            </div>

            <div className="input_container">
              <label className="form_label" htmlFor="full-name">Full Name</label>
              <input className="form_input name" id="full-name" name='name' type="text" placeholder="Ex: Joh Doe" required />
            </div>
            <div className="input_container">
              <label className="form_label" htmlFor="bio">Bio</label>
              <input className="form_input bio" id="bio" name='bio' type="text" placeholder="Ex: Software Engineer" required />
            </div>
            <div className="input_container">
              <label className="form_label" htmlFor="email">Email <Link to='/update-email'>Update Email</Link></label>
              <input className="form_input input-indicator-n email" name='email' id="email" type="email" placeholder="Ex: example@example.com" readOnly />
            </div>
            <div className="input_container">
              <label className="form_label" htmlFor="mobile-number">Mobile Number <Link to='/update-email'>Edit Mobile No.</Link></label>
              <input className="form_input mobile_number input-indicator-n" id="mobile-number" name='mobileNumber' min="01111111111" minLength="11" maxLength="11" type="number" placeholder="Ex: 01*********" readOnly />
            </div>
          </div>

          <div className='actions'>
            <Link style={{float: 'right', padding: '0 20px', marginBottom: '30px'}} to='/update-password' className='btn_primary bx_shadow ripple-animate ripple-dark bg-1' type='submit'>Change Password</Link>
            <button className='btn_primary bx_shadow submit_btn ripple-animate ripple-dark bg-2 w-100' type='submit' disabled={true}>Update Profile</button>
          </div>
        </form>
      </div>
    </div>
  )
}
